module.exports = __webpack_public_path__ + "static/media/bg-home.3801763a.svg";